'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00243 from "./dev.cheleb.scalamigen.-Form$$anon$3.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dIron$002dType$002dValidator$0024given$005f$002dIron$002dType$002dValidator$005f$002dA$005f$002dC from "./dev.cheleb.scalamigen.-Iron-Type-Validator$given_-Iron-Type-Validator_-A_-C.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dValidator$0024given$005f$002dValidator$005f$002dDouble$0024 from "./dev.cheleb.scalamigen.-Validator$given_-Validator_-Double$.js";
import * as $j_io$002egithub$002eiltotore$002eiron$002e$002dRuntime$002dConstraint from "./io.github.iltotore.iron.-Runtime-Constraint.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$35() {
}
export { $c_Lsamples_Persons$package$$anon$35 as $c_Lsamples_Persons$package$$anon$35 };
$p = $c_Lsamples_Persons$package$$anon$35.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$35;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$35() {
}
export { $h_Lsamples_Persons$package$$anon$35 as $h_Lsamples_Persons$package$$anon$35 };
$h_Lsamples_Persons$package$$anon$35.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.a5 = (function() {
  return new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00243.$c_Ldev_cheleb_scalamigen_Form$$anon$3(new $j_dev$002echeleb$002escalamigen$002e$002dIron$002dType$002dValidator$0024given$005f$002dIron$002dType$002dValidator$005f$002dA$005f$002dC.$c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC($j_dev$002echeleb$002escalamigen$002e$002dValidator$0024given$005f$002dValidator$005f$002dDouble$0024.$m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fDouble$(), new $j_io$002egithub$002eiltotore$002eiron$002e$002dRuntime$002dConstraint.$c_Lio_github_iltotore_iron_RuntimeConstraint(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$3) => ((+_$1$3) > 0.0))), "Should be strictly positive")));
});
$p.h = (function() {
  return this.a5();
});
var $d_Lsamples_Persons$package$$anon$35 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$35, "samples.Persons$package$$anon$35", ({
  pR: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$35 as $d_Lsamples_Persons$package$$anon$35 };
